import {contraConstants} from "./ContraConstants";

const {
    SAVE_CONTRA_ERROR,
    SAVE_CONTRA_START,
    SAVE_CONTRA_SUCCESS,
    EDIT_CONTRA_ERROR,
    EDIT_CONTRA_START,
    EDIT_CONTRA_SUCCESS,
    PREVIEW_CONTRA_ERROR,
    PREVIEW_CONTRA_START,
    PREVIEW_CONTRA_SUCCESS,
    SEARCH_CONTRA_ERROR,
    SEARCH_CONTRA_START,
    SEARCH_CONTRA_SUCCESS,
    DELETE_CONTRA_ERROR,
    DELETE_CONTRA_START,
    DELETE_CONTRA_SUCCESS
} = contraConstants

export const saveContraStart = () => ({
    type: SAVE_CONTRA_START
})
export const saveContraSuccess = data => ({
    type: SAVE_CONTRA_SUCCESS,
    payload: {
        data: data
    }
})
export const saveContraError = (errorMessage) => ({
    type: SAVE_CONTRA_ERROR,
    payload: {
        data: errorMessage
    }
})
export const searchContraStart = () => ({
    type: SEARCH_CONTRA_START
})
export const searchContraSuccess = data => ({
    type: SEARCH_CONTRA_SUCCESS,
    payload: {
        data: data
    }
})
export const searchContraError = (errorMessage) => ({
    type: SEARCH_CONTRA_ERROR,
    payload: {
        data: errorMessage
    }
})
export const previewContraStart = () => ({
    type: PREVIEW_CONTRA_START
})
export const previewContraSuccess = data => ({
    type: PREVIEW_CONTRA_SUCCESS,
    payload: {
        data: data
    }
})
export const previewContraError = (errorMessage) => ({
    type: PREVIEW_CONTRA_ERROR,
    payload: {
        data: errorMessage
    }
})
export const editContraStart = () => ({
    type: EDIT_CONTRA_START
})
export const editContraSuccess = data => ({
    type: EDIT_CONTRA_SUCCESS,
    payload: {
        data: data
    }
})
export const editContraError = (errorMessage) => ({
    type: EDIT_CONTRA_ERROR,
    payload: {
        data: errorMessage
    }
})

export const deleteContraStart = () => ({
    type: DELETE_CONTRA_START
})
export const deleteContraSuccess = data => ({
    type: DELETE_CONTRA_SUCCESS,
    payload: {
        data: data
    }
})
export const deleteContraError = (errorMessage) => ({
    type: DELETE_CONTRA_ERROR,
    payload: {
        data: errorMessage
    }
})